module.exports = __webpack_public_path__ + "static/img/yang1.37dac6b1.jpg";